<template>
<div>
  <el-card body-style="padding: 0">
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">站内信息管理</span>
    </div>
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="发送用户" prop="userName">
            <el-input v-model="queryForm.userName" placeholder="请输入手机号"/>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="4">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询
            </el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
  <el-card>
    <el-table :data="tableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}"
              @selection-change="handleSelectionChange">
      <el-table-column label="序号" width="80">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="sendUserName" label="用户账户"/>
      <el-table-column prop="message" label="消息内容">
        <template slot-scope="scope">
          <span v-if="scope.row.msgType==0">
            {{scope.row.message}}
          </span>
          <span v-if="scope.row.msgType==1">
            <el-image
                style="width: 64px; height: 64px"
                :src="scope.row.message"
                lazy>
            </el-image>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="msgStatusStr" label="消息状态"/>
      <el-table-column prop="msgTypeStr" label="消息类型"/>
      <el-table-column prop="createTime" label="发送时间"/>
      <el-table-column prop="remarks" label="备注"/>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" plain
                     @click="handleActiveUserEdit(scope.$index, scope.row)">
            回信息
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
</div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {queryMsgList} from "../../api/b2cbusiness/b2c_admin";
import ChatMessageDialog from "../imessage/ChatMessageDialog";

export default {
name: "B2cImessageList",
  components: {ChatMessageDialog},
  mixins: [MixinCUD],
  data(){
  return {
    tableData: [],
    queryFormRefName:"queryForm",
    queryForm: {},
    activeUserName: "admin",
    isShowDialog: false,
    pagination: {
      pageNum: 1,
      pageSize: 20,
      total: null
    },
  }
  },
  mounted() {
     if (this.$route.query.msgStatus != null){
       this.queryForm.msgStatus = this.$route.query.msgStatus;
     }
     this.getData();
  },
  methods:{
    handleActiveUserEdit(index, row){
      this.$chatmsg({
        dialogTitle: row.activeUserName,
      })
    },
  getData(){
    queryMsgList(this.queryForm, this.pagination).then(res=>{
      if (res.success){
        this.tableData = res.data.records;
        this.pagination.pageNum = res.data.current;
        this.pagination.pageSize = res.data.size;
        this.pagination.total = res.data.total;
      }
    });
  },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-tree--highlight-current /deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(31, 158, 254);
  color: rgb(255, 255, 255);
}
</style>
